// src/components/Configuraciones/Perfil.jsx
import React, { useEffect, useState, useMemo } from "react";
import { useAuth } from "../../context/AuthContext";
import {
  obtenerPerfil,
  solicitarPinVerificarCorreo,
  actualizarPerfil,
  solicitarPinCambioPassword,
  cambiarPasswordConPin,




} from "../../services/usuarioService";
import { usePermisos } from "../../context/PermisosContext";
import { isSuperAdmin as isSuperFromJwt } from "../../services/authUtils";

const Perfil = () => {
  const { user } = useAuth(); // { id, email, nombre, rol?, esTemporal?, esSuperAdmin? }
  const { canEdit } = usePermisos();

  // Robustez: detectar superadmin desde JWT/localStorage/prop
  const esSuperAdmin = useMemo(() => {
    if (isSuperFromJwt()) return true;
    if (localStorage.getItem("esSuperAdmin") === "true") return true;
    if (user?.esSuperAdmin === true || user?.esSuperAdmin === "true") return true;
    return (user?.rol || "").toString().toLowerCase().includes("super");
  }, [user]);

  const esTemporal =
    Boolean(user?.esTemporal) ||
    (user?.rol && String(user.rol).toLowerCase().includes("temporal"));

  const puedeEditarPerfil = (canEdit && canEdit("CONFIGURACIONES_EDIT")) ?? true;



  // ----- Perfil -----
  const [nombre, setNombre] = useState("");
  const [emailActual, setEmailActual] = useState("");
  const [emailNuevo, setEmailNuevo] = useState("");
  const [pinEmail, setPinEmail] = useState("");
  const [paisCodigo, setPaisCodigo] = useState("");
  const [regionCodigo, setRegionCodigo] = useState("");
  const [municipioNombre, setMunicipioNombre] = useState("");
  const [zonaHorariaId, setZonaHorariaId] = useState("");
  const [catalogo, setCatalogo] = useState(null);
  const [paises, setPaises] = useState([]);
  const [regiones, setRegiones] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [zonasHorarias, setZonasHorarias] = useState([]);
  const [cargandoUbicaciones, setCargandoUbicaciones] = useState(true);

  // ----- Password con PIN -----
  const [pinPassword, setPinPassword] = useState("");
  const [passwordNueva, setPasswordNueva] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  // ----- Temporales -----



  // ----- UI -----
  const [cargandoPerfil, setCargandoPerfil] = useState(false);
  const [msg, setMsg] = useState("");

  const loadPerfil = async () => {
    setCargandoPerfil(true);
    setMsg("");
    try {
      const { data } = await obtenerPerfil();
      setNombre(data?.nombre || "");
      setEmailActual(data?.email || "");
      setPaisCodigo(data?.paisCodigo || "");
      setRegionCodigo(data?.regionCodigo || "");
      setMunicipioNombre(data?.municipioNombre || "");
      setZonaHorariaId(data?.zonaHorariaId || "");
      setEmailNuevo("");
      setPinEmail("");
      setPinPassword("");
      setPasswordNueva("");
      setPasswordConfirm("");
    } catch (e) {
      setMsg("❌ No se pudo cargar el perfil.");
      console.error(e);
    } finally {
      setCargandoPerfil(false);
    }
  };


  useEffect(() => {
    loadPerfil();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [esTemporal, esSuperAdmin]);

  useEffect(() => {
    let activo = true;
    import("country-state-city").then(({ Country, State, City }) => {
      if (!activo) return;
      setCatalogo({ Country, State, City });
      setPaises(Country.getAllCountries().sort((a, b) => a.name.localeCompare(b.name, "es")));
      setCargandoUbicaciones(false);
    }).catch((error) => {
      console.error("No se pudo cargar el catálogo mundial", error);
      if (activo) setCargandoUbicaciones(false);
    });
    return () => { activo = false; };
  }, []);

  useEffect(() => {
    if (!catalogo || !paisCodigo) {
      setRegiones([]); setMunicipios([]); setZonasHorarias([]); return;
    }
    const pais = catalogo.Country.getCountryByCode(paisCodigo);
    setRegiones(catalogo.State.getStatesOfCountry(paisCodigo).sort((a, b) => a.name.localeCompare(b.name, "es")));
    setZonasHorarias(pais?.timezones || []);
  }, [catalogo, paisCodigo]);

  useEffect(() => {
    if (!catalogo || !paisCodigo || !regionCodigo) { setMunicipios([]); return; }
    setMunicipios(catalogo.City.getCitiesOfState(paisCodigo, regionCodigo).sort((a, b) => a.name.localeCompare(b.name, "es")));
  }, [catalogo, paisCodigo, regionCodigo]);

  const handleEnviarPinEmail = async () => {
    try {
      if (!emailNuevo || emailNuevo === emailActual) {
        setMsg("⚠️ Ingresa un correo distinto para solicitar el PIN.");
        return;
      }
      await solicitarPinVerificarCorreo(emailNuevo, emailActual);
      setMsg("✅ PIN enviado al nuevo correo. Revísalo y pégalo abajo.");
    } catch (e) {
      setMsg("❌ Error al enviar PIN al nuevo correo.");
      console.error(e);
    }
  };

  const handleGuardarDatos = async (e) => {
    e.preventDefault();
    setMsg("");
    if (!puedeEditarPerfil) {
      setMsg("⚠️ No tienes permisos para editar el perfil.");
      return;
    }
    try {
      const payload = {
        nombre,
        // El correo sólo se envía cuando realmente se solicita cambiarlo;
        // así guardar país/zona horaria no exige un PIN de correo.
        email: emailNuevo || null,
        tokenCorreo: emailNuevo ? pinEmail : undefined,
        paisCodigo: paisCodigo || null,
        paisNombre: paises.find((x) => x.isoCode === paisCodigo)?.name || null,
        regionCodigo: regionCodigo || null,
        regionNombre: regiones.find((x) => x.isoCode === regionCodigo)?.name || null,
        municipioNombre: municipioNombre || null,
        zonaHorariaId: zonaHorariaId || null,
      };
      await actualizarPerfil(payload);
      setMsg("✅ Datos actualizados.");
      await loadPerfil();
    } catch (e) {
      setMsg("❌ No se pudieron guardar los datos.");
      console.error(e);
    }
  };

  const handleEnviarPinPassword = async () => {
    try {
      await solicitarPinCambioPassword(emailActual);
      setMsg("✅ PIN enviado a tu correo para cambiar contraseña.");
    } catch (e) {
      setMsg("❌ Error al enviar PIN de contraseña.");
      console.error(e);
    }
  };

  const handleCambiarPassword = async (e) => {
    e.preventDefault();
    setMsg("");
    if (passwordNueva.length < 6) {
      setMsg("⚠️ La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (passwordNueva !== passwordConfirm) {
      setMsg("⚠️ Las contraseñas no coinciden.");
      return;
    }
    try {
      await cambiarPasswordConPin({
        email: emailActual,
        pin: pinPassword,
        nuevaPassword: passwordNueva,
      });
      setMsg("✅ Contraseña actualizada.");
      setPinPassword("");
      setPasswordNueva("");
      setPasswordConfirm("");
    } catch (e) {
      setMsg("❌ No se pudo cambiar la contraseña. Revisa el PIN.");
      console.error(e);
    }
  };


  return (
    <div className="p-4 sm:p-6 bg-neutral-900 text-white rounded-lg max-w-6xl mx-auto">
      <h2 className="text-xl sm:text-2xl font-bold text-green-400 mb-4">Perfil</h2>

      {msg && (
        <div
          className={`mb-3 text-sm ${
            msg.startsWith("✅")
              ? "text-green-400"
              : msg.startsWith("⚠️")
              ? "text-yellow-300"
              : "text-red-400"
          }`}
        >
          {msg}
        </div>
      )}

      {cargandoPerfil ? (
        <div className="text-gray-300">Cargando…</div>
      ) : (
        <>
          {/* Datos básicos */}
          <form onSubmit={handleGuardarDatos} className="space-y-4 mb-6">
            <div>
              <label className="block text-sm mb-1">Nombre</label>
              <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                className="w-full px-3 py-2 rounded bg-neutral-800 border border-neutral-700"
                disabled={!puedeEditarPerfil}
                required
              />
            </div>

            <fieldset className="rounded-lg border border-cyan-900/70 bg-cyan-950/10 p-4">
              <legend className="px-2 font-semibold text-cyan-300">Ubicación y hora local</legend>
              <p className="mb-3 text-xs text-neutral-400">Se utiliza para presentar fechas y ejecutar horarios en la zona correcta.</p>
              <div className="grid gap-3 md:grid-cols-2">
                <label className="text-sm">País
                  <select value={paisCodigo} onChange={(e) => { setPaisCodigo(e.target.value); setRegionCodigo(""); setMunicipioNombre(""); setZonaHorariaId(""); }} disabled={!puedeEditarPerfil || cargandoUbicaciones} className="mt-1 w-full rounded border border-neutral-700 bg-neutral-800 px-3 py-2">
                    <option value="">Selecciona un país</option>
                    {paises.map((x) => <option key={x.isoCode} value={x.isoCode}>{x.flag} {x.name}</option>)}
                  </select>
                </label>
                <label className="text-sm">Estado, departamento o región
                  <select value={regionCodigo} onChange={(e) => { setRegionCodigo(e.target.value); setMunicipioNombre(""); }} disabled={!puedeEditarPerfil || !paisCodigo} className="mt-1 w-full rounded border border-neutral-700 bg-neutral-800 px-3 py-2">
                    <option value="">Selecciona una región</option>
                    {regiones.map((x) => <option key={x.isoCode} value={x.isoCode}>{x.name}</option>)}
                  </select>
                </label>
                <label className="text-sm">Municipio o ciudad
                  <select value={municipioNombre} onChange={(e) => setMunicipioNombre(e.target.value)} disabled={!puedeEditarPerfil || !regionCodigo} className="mt-1 w-full rounded border border-neutral-700 bg-neutral-800 px-3 py-2">
                    <option value="">Selecciona un municipio o ciudad</option>
                    {municipios.map((x, i) => <option key={`${x.name}-${i}`} value={x.name}>{x.name}</option>)}
                  </select>
                </label>
                <label className="text-sm">Zona horaria
                  <select value={zonaHorariaId} onChange={(e) => setZonaHorariaId(e.target.value)} disabled={!puedeEditarPerfil || !paisCodigo} className="mt-1 w-full rounded border border-neutral-700 bg-neutral-800 px-3 py-2">
                    <option value="">Selecciona una zona horaria</option>
                    {zonasHorarias.map((x) => <option key={x.zoneName} value={x.zoneName}>{x.zoneName} ({x.gmtOffsetName})</option>)}
                  </select>
                </label>
              </div>
            </fieldset>

            <div>
              <label className="block text-sm mb-1">Correo actual</label>
              <input
                type="email"
                value={emailActual}
                disabled
                className="w-full px-3 py-2 rounded bg-neutral-800 border border-neutral-700 cursor-not-allowed text-gray-300"
              />
            </div>

            <div>
              <label className="block text-sm mb-1">
                Nuevo correo {esTemporal && <span className="text-gray-400">(opcional)</span>}
              </label>
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  value={emailNuevo}
                  onChange={(e) => setEmailNuevo(e.target.value)}
                  placeholder="usuario@ejemplo.com"
                  className="flex-1 px-3 py-2 rounded bg-neutral-800 border border-neutral-700"
                  disabled={!puedeEditarPerfil}
                />
                <button
                  type="button"
                  onClick={handleEnviarPinEmail}
                  disabled={!puedeEditarPerfil || !emailNuevo || emailNuevo === emailActual}
                  className="px-3 py-2 rounded bg-cyan-700 hover:bg-cyan-600 disabled:opacity-50"
                >
                  Enviar PIN
                </button>
              </div>
              {emailNuevo && (
                <input
                  type="text"
                  value={pinEmail}
                  onChange={(e) => setPinEmail(e.target.value)}
                  placeholder="PIN recibido en el nuevo correo"
                  className="mt-2 w-full px-3 py-2 rounded bg-neutral-800 border border-neutral-700"
                  disabled={!puedeEditarPerfil}
                />
              )}
              <p className="text-xs text-gray-400 mt-1">
                Para confirmar el cambio de correo se requiere el PIN enviado al nuevo correo.
              </p>
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                disabled={!puedeEditarPerfil}
                className="px-4 py-2 rounded bg-green-600 hover:bg-green-700 disabled:opacity-50"
              >
                Guardar datos
              </button>
            </div>
          </form>

          {/* Cambiar contraseña */}
          <form onSubmit={handleCambiarPassword} className="space-y-4 border-t border-neutral-800 pt-5 mb-8">
            <h3 className="text-lg font-semibold text-cyan-300">Cambiar contraseña</h3>

            <div className="flex flex-col sm:flex-row gap-2">
              <button
                type="button"
                onClick={handleEnviarPinPassword}
                className="px-3 py-2 rounded bg-purple-700 hover:bg-purple-600"
              >
                Enviar PIN al correo
              </button>
              <input
                type="text"
                value={pinPassword}
                onChange={(e) => setPinPassword(e.target.value)}
                placeholder="PIN de verificación"
                className="flex-1 px-3 py-2 rounded bg-neutral-800 border border-neutral-700"
                required
              />
            </div>

            <div className="grid sm:grid-cols-2 gap-3">
              <div>
                <label className="block text-sm mb-1">Nueva contraseña</label>
                <input
                  type="password"
                  value={passwordNueva}
                  onChange={(e) => setPasswordNueva(e.target.value)}
                  className="w-full px-3 py-2 rounded bg-neutral-800 border border-neutral-700"
                  minLength={6}
                  required
                />
              </div>
              <div>
                <label className="block text-sm mb-1">Confirmar contraseña</label>
                <input
                  type="password"
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                  className="w-full px-3 py-2 rounded bg-neutral-800 border border-neutral-700"
                  minLength={6}
                  required
                />
              </div>
            </div>

            <div className="flex justify-end">
              <button type="submit" className="px-4 py-2 rounded bg-green-600 hover:bg-green-700">
                Cambiar contraseña
              </button>
            </div>
          </form>

          <a className="text-cyan-300" href="/dashboard/admin?tab=Usuarios+Temporales&sub=administrar">Administrar usuarios temporales y permisos</a>
        </>
      )}
    </div>
  );
};

export default Perfil;
